module.exports = __webpack_public_path__ + "static/media/vi.9c3cc1e8.png";